import { render } from "./DialogEditorCmp.vue?vue&type=template&id=2f47b752"
import script from "./DialogEditorCmp.vue?vue&type=script&lang=js"
export * from "./DialogEditorCmp.vue?vue&type=script&lang=js"

import "./DialogEditorCmp.vue?vue&type=style&index=0&id=2f47b752&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__